import React, { useState, useEffect, useContext } from "react";
import ConsultantItem from "./ConsultantItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AuthContext } from "../context/AuthContext";
import PublicService from "../services/PublicService";
import AdminService from "../services/AdminService";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Consultants = () => {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const [consultants, setConsultants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterOfficeLocation, setFilterOfficeLocation] = useState("All");
  const [filterRole, setFilterRole] = useState("All");

  const rolesSortOrder = {
    externaluser: -4,
    user: -3,
    "admin/user": -2,
    admin: -1,
  };
  const updateFilter = (e) => {
    const capitalizeInput = e.target.value;
    setFilterOfficeLocation(capitalizeInput);    
  };

  const onFilterRole = (e) => {
    setFilterRole(e.target.value);
  };

  useEffect(() => {
    if (authContext.user.role.includes("admin")) {
      AdminService.getConsultantsAdmin().then((data) => {
        if (data && data.users) {
          setLoading(false);
          setConsultants(data.users);
        }
      });
    } else {
      if (!authContext.user.role.includes("externaluser")) {
        PublicService.getConsultants().then((data) => {
          if (data && data.users) {
            setLoading(false);
            setConsultants(data.users);
          }
        });
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "1.5%" }}>Consultants</h1>
      <div style={{ display: "flex" }}>
        <FormControl className={classes.formControl}>
          <Select
            name="siteLocation"
            value={filterOfficeLocation}
            onChange={updateFilter}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Göteborg">Göteborg</MenuItem>
            <MenuItem value="Linköping">Linköping</MenuItem>
          </Select>
          <FormHelperText>Site Location</FormHelperText>
        </FormControl>
        <FormControl className={classes.formControl}>
          <Select name="role" value={filterRole} onChange={onFilterRole}>
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="admin">Admin</MenuItem>
            <MenuItem value="user">User</MenuItem>
            <MenuItem value="externaluser">External User</MenuItem>
          </Select>
          <FormHelperText>User Role</FormHelperText>
        </FormControl>
      </div>
      {loading && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "10%",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      )}
      {!loading && (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              marginTop: "3%",
            }}
          >
            {consultants === undefined || consultants.length <= 0 ? (
              <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
                No consultants...
              </p>
            ) : (
              consultants
                .sort(function (a, b) {
                  var x = rolesSortOrder[a.role];
                  var y = rolesSortOrder[b.role];
                  if (x < y) {
                    return -1;
                  }
                  if (x > y) {
                    return 1;
                  }
                  return 0;
                })
                .filter(
                  (consultant) =>
                    (filterOfficeLocation === "All"
                      ? true
                      : consultant.officeLocation
                      ? consultant.officeLocation.includes(filterOfficeLocation)
                      : false) &&
                    (filterRole === "All"
                      ? true
                      : consultant.role
                      ? consultant.role === filterRole
                      : false)
                )
                .map((consultant) => (
                  <ConsultantItem
                    key={consultant._id}
                    consultant={consultant}
                  />
                ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Consultants;
